import axios from 'axios'
import store from '@/store'
import main from '@/main.js'
import vconsole from 'vconsole'
let instance = axios.create({
	headers: {
		'content-type': 'application/x-www-form-urlencoded',
	}
})
instance.interceptors.request.use(
	config => {
		return config
	},
	err => {
		return Promise.reject([null, err])
	}
)

// http response 拦截器
instance.interceptors.response.use(
	res => {
		if ([111, 103, 110].indexOf(res.data.code) != -1) {
			main.$Login.show(() => {})
			main.$Toast.show('请通过验证码登录')
		} else if (res.data.code != 0) {
			main.$Toast.show(res.data.msg)
		}
		return res
	},
	//接口错误状态处理，也就是说无响应时的处理
	err => {
		main.$Toast.show(err.response.data.msg)
		return Promise.reject(err.response) // 返回接口返回的错误信息
	}
)


let BASE_URL = null
let GAME_ID = null
if (process.env.NODE_ENV == 'test') {
	BASE_URL = 'http://sdktest.gateway.yofijoy.com'
	GAME_ID = 1
	new vconsole()
} else if (process.env.NODE_ENV == 'development') {
	BASE_URL = 'http://sdktest.gateway.yofijoy.com'
	GAME_ID = 1
	new vconsole()
} else if (process.env.NODE_ENV == 'production') {
	BASE_URL = 'https://swapis.gateway.yofijoy.com'
	GAME_ID = 10005
}

export default {
	post(path, data) {

		let formData = new FormData()
		Object.keys(data).sort().forEach(key => {
			formData.append(key, data[key])
		})
		formData.append('gameId', GAME_ID)
		formData.append('accessToken', store.getters.accessToken)
		return new Promise((rev, rej) => {
			instance.post(BASE_URL + path, formData).then(res => {
				rev([res, null])
			}).catch((e) => {
				rej([null, e])
			})
		})
	},
	get(path, data) {
		data.gameId = GAME_ID
		data.accessToken = store.getters.accessToken
		return new Promise((rev, rej) => {
			instance.get(BASE_URL + path, {
				params: data,
			}).then(res => {
				rev([res, null])
			}).catch((e) => {
				rej([null, e])
			})
		})
	},
	ok(res) {
		return (res[0] && res[0].data.code == 0) ? true : false
	},
	find(res, array) {
		return !!array.find(item => item == res[0].data.code)
	}
}
